import { useDispatch } from 'react-redux';

export const customerSatisfactionSurveyQuestions = {
  jusfinder: {
    lawsuit: 'Como você avalia a sua experiência com o Buscador Processual?',
    personal_data:
      'Como você avalia a sua experiência com a Consulta de Localização?',
    relationship_tree:
      'Como você avalia a sua experiência com a Consulta de Relacionamentos?',
    list_vehicles:
      'Como você avalia a sua experiência com a Consulta de Veículos?',
    vehicle_data:
      'Como você avalia a sua experiência com a Consulta de Dados do Veículo?',
    company_partnership:
      'Como você avalia a sua experiência com a Consulta de Sociedades?',
    company_information:
      'Como você avalia a sua experiência com a Consulta de Empresa Completa?',
    credit_restriction:
      'Como você avalia a sua experiência com a Consulta de Restrição de Crédito?',
    professional_data:
      'Como você avalia a sua experiência com a Consulta de Dados Profissionais?',
    trademarks:
      'Como você avalia a sua experiência com a Consulta de Marcas e Patentes?',
    cpf_registration_status:
      'Como você avalia a sua experiência com a Consulta de Situação Cadastral de CPF?',
    economic_group:
      'Como você avalia a sua experiência com a Consulta de Grupos Econômicos?',
    vehicle_tracking:
      'Como você avalia a sua experiência com a Consulta de Rastreamento de veículos?',
    driver_license_data:
      'Como você avalia a sua experiência com a Consulta de Dados da CNH?',
    vehicle_debits:
      'Como você avalia a sua experiência com a Consulta de Débitos de Veículos?',
    phone_data:
      'Como você avalia a sua experiência com a Consulta de Dados por Telefone?',
    rural_property:
      'Como você avalia a sua experiência com a Consulta de Imóveis Rurais (CAR/SNCR)?',
    financed_properties:
      'Como você avalia a sua experiência com a Consulta de Imóveis Financiados?',
  },
};

function useCustomerSatisfactionSurvey(
  feature_name,
  title,
  timeoutMilliseconds = 0,
) {
  const dispatch = useDispatch();

  if (!feature_name)
    return () => {
      console.log(`CSAT feature name "${feature_name}" incorrectly supplied`);
    };
  if (!title)
    return () => {
      console.log(`CSAT question "${title}" incorrectly supplied`);
    };

  return () => {
    setTimeout(() => {
      dispatch({
        type: 'INITIATE_CSAT_SURVEY',
        payload: {
          feature_name,
          pretty_name: title,
        },
      });
    }, timeoutMilliseconds);
  };
}

export default useCustomerSatisfactionSurvey;
